import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import $ from "jquery"
import { InputCustom, Base64Input } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Layout from "../../Layout"
import { LoadModal } from "../../modais"
class DigitalizadosCreateForm extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      files: [],
      file: "",
      fileName: "",
      showLoad: false,
      errors: []
    }
  }
  componentDidUpdate() {
    //Pequeno ajuste tecnico devido bug no datepicker
    $(".is-empty").removeClass("is-empty")
  }
  getFiles(files) {
    const currentFiles = this.state.files
    currentFiles.push(...files)
    this.setState({
      arquivosError: [],
      errors: [],
      files: files
    })
  }
  sendForm(event) {
    event.preventDefault()
    const arquivos = this.state.files.map(file => {
      var fileName = file.name.split(".pdf").join("")
      fileName = fileName.split(".png").join("")
      fileName = fileName.split(".jpg").join("")
      fileName = fileName.split(".jpeg").join("")
      var base64 = file.base64.split("data:" + file.type + ";base64,").join("")
      return {
        contrato_file: base64,
        file_name: fileName,
        contrato_id: this.props.match.params.id
      }
    })
    var params = {
      arquivos: arquivos
    }
    this.toggleLoadModal()
    ApiHelper.sendContratoDigitalizado(params, error => {
      this.toggleLoadModal()
      if (error) {
        this.handleErrors(error)
      } else {
        this.props.history.push("/digitalizados/" + this.props.match.params.id)
      }
    })
  }
  deleteFile(index) {
    const files = this.state.files
    files.splice(index, 1)
    this.setState({
      files: files
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    errorsState.errors = {}
    for (var key in errorsValue) {
      if (key.includes(".contrato_file")) {
        const index = key.split(".")[1]
        errorsState.errors[index] = errorsValue[key][0]
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    this.setState(errorsState)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <div className="container-fluid">
          <div>
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Digitalizar arquivo</h4>
                <p className="category">
                  Enviar para o sistemas arquivos relacionados ao contrato
                </p>
              </div>
              <div className="card-content">
                <form>
                  <div className="row">
                    <Base64Input
                      ref={ref => (this.upload = ref)}
                      style={{ display: "none" }}
                      multiple={true}
                      onDone={this.getFiles.bind(this)}
                    />
                    <div className="col-md-10">
                      <button
                        onClick={e => this.upload.click()}
                        type="button"
                        className="btn btn-danger"
                      >
                        Carregar arquivos
                        <i className="material-icons">file_upload</i>
                      </button>
                      <br />
                      <span className="label label-danger">
                        {this.state.arquivosError}
                      </span>
                    </div>
                  </div>
                  {this.state.files.map((file, key) => {
                    return (
                      <div key={key} className="row">
                        <InputCustom
                          error={
                            (this.state.errors[key] || { file_nameError: "" })
                              .file_nameError
                          }
                          sizeClass="col-md-10"
                          label="Nome do arquivo"
                          type="text"
                          disabled={true}
                          value={file.name}
                        />
                        <div className="col-md-2">
                          <button
                            onClick={() => this.deleteFile(key)}
                            type="button"
                            className="btn btn-primary pull-left"
                            data-background-color="red"
                          >
                            <i className="icon-header material-icons">delete</i>
                          </button>
                        </div>
                      </div>
                    )
                  })}
                  <div className="row">
                    <br />
                    <button
                      onClick={this.sendForm}
                      type="submit"
                      className="btn btn-primary pull-left"
                      data-background-color="as-blue"
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
export default withRouter(DigitalizadosCreateForm)



// WEBPACK FOOTER //
// ./src/views/contratos/digitalizados/DigitalizadosCreateForm.js